import { FaUser, FaPhoneAlt, FaClipboardCheck, FaStickyNote } from 'react-icons/fa';
export const mostrarElegibilidad = (estadoLlamadaId, subestadoLlamadaId) => {
  if (!estadoLlamadaId) return false;
  if (estadoLlamadaId === 2) return false;
  if (estadoLlamadaId === 3) return true;
  if (estadoLlamadaId === 1 && subestadoLlamadaId === 4) return true;
  return false;
};
export const getVisibleSteps = (mostrarEleg) => {
  const steps = [
    { key: 0, title: 'Participante', icon: <FaUser /> },
    { key: 1, title: 'Llamada', icon: <FaPhoneAlt /> }
  ];
  if (mostrarEleg) {
    steps.push({ key: 2, title: 'Elegibilidad', icon: <FaClipboardCheck /> });
  }
  steps.push({ key: 3, title: 'Observación', icon: <FaStickyNote /> });
  return steps;
};

export const getAdjustedCurrentStep = (currentStep, visibleSteps) => {
  const currentStepKey = visibleSteps.find(step => step.key === currentStep)?.key;
  if (currentStepKey === undefined) {
    const lastVisibleStep = visibleSteps[visibleSteps.length - 2];
    return lastVisibleStep ? lastVisibleStep.key : 0;
  }
  return currentStep;
};
export const validarStep = (
  step,
  estadoLlamadaId,
  subestadoLlamadaId,
  estadoSeleccionado,
  mostrarEleg,
  esElegible,
  motivoNoElegibleId,
  requiereUbicacion,
  departamentoFueraTerritorio,
  municipioFueraTerritorio,
  observacionNoElegible,
  motivoSeleccionado,
  motivoOtroSeleccionadoId, // <-- Cambiado
  motivosOtro, // <-- Agregado
  motivoOtroOtro // <-- Cambiado
) => {
  const getAdjustedStepNumber = (stepNum) => {
    return stepNum;
  };

  const adjustedStep = getAdjustedStepNumber(step);

  switch (adjustedStep) {
    case 0:
      return true;
    case 1:
      if (!estadoLlamadaId) return false;
      if (estadoSeleccionado?.permite_subestados && !subestadoLlamadaId) return false;
      return true;
    case 2:
      if (!mostrarEleg) return true;
      if (esElegible === null) return false;
      if (esElegible === false) {
        if (!motivoNoElegibleId) return false;
        
        // Validar si es motivo "Otro"
        if (motivoSeleccionado?.codigo === 'OTRO') {
          // Validar que se haya seleccionado una opción
          if (!motivoOtroSeleccionadoId) return false;
          
          // Si seleccionó "¿Cuál?", validar que haya escrito algo
          const motivoOtroSeleccionado = motivosOtro?.find(m => m.id === motivoOtroSeleccionadoId);
          if (motivoOtroSeleccionado?.codigo === 'CUAL' && (!motivoOtroOtro || motivoOtroOtro.trim() === '')) {
            return false;
          }
        }
        
        if (requiereUbicacion && (!departamentoFueraTerritorio || !municipioFueraTerritorio)) {
          return false;
        }
        if (!observacionNoElegible || observacionNoElegible.trim() === '') {
          return false;
        }
      }
      return true;
    case 3:
      return true;
    default:
      return false;
  }
};